<template lang="pug">
    section#conteudo
        div.wrapper
            //- h2 Convênios em Destaque:
            //- ul#destaques
                li
                    img(:src="require('@images/convenios/caramuru-itumbiara.png')", alt="Caramuru Itumbiara")
                li
                    img(:src="require('@images/convenios/ssa-itaberai.png')", alt="SSA Itaberaí")
            h2.confira Empresas conveniadas:
        div.seletores(v-if="estados != null")
            div.select
                label Selecione o Estado:
                select(@change="toggleEstado()", v-model="selectEstadoId")
                    option(value="", disabled, selected) Selecione um Estado
                    option(:value="estado.id", v-for="estado in estados", v-html='$utils.getEstadoByUF(estado.nome)')
                
            div.select
                label Selecione a Cidade:
                select(@change="toggleCidade()", v-model="selectCidadeId")
                    option(value="", disabled, selected) Selecione uma Cidade
                    option(:value="cidade.id", v-for="cidade in cidades") {{ cidade.nome }}

        div.tabela
            table(v-if="empresas != null && empresas.length > 0")
                thead
                    tr
                        th Nome da Empresa
                        th Graduação
                        th Pós-Graduação
                tbody
                    tr(v-for="empresa in empresas")
                        td {{ empresa.empresa }}
                        td 
                            a(:href="empresa.link_grad", target="_blank") {{ empresa.link_grad }}
                        td
                            a(:href="empresa.link_pos", target="_blank") {{ empresa.link_pos }}
            p(v-if="(estados != null && cidades != null && empresas != null) && empresas.length == 0") Não foram encontradas empresas conveniadas para o estado e cidade pesquisadas. Por favor, tente outra busca.
</template>

<script>
export default {
    name: "section-conteudo",
    data() {
        return {
            estados: [],
            selectEstadoId: "",
            cidades: null,
            selectCidadeId: "",
            empresas: null,
        }
    },
    created() {
        this.loadEstados()
    },
    methods: {
        loadEstados() {
            this.$axios
                .get(`convenio/estados`)
                .then(response => {
                    this.estados = response.data;
                })
        },
        loadCidades(estadoId) {
            this.$axios
                .get(`convenio/cidades/${estadoId}`)
                .then(response => {
                    this.cidades = response.data;
                })
        },
        loadEmpresas(cidadeId) {
            this.$axios
                .get(`convenio/${cidadeId}/empresas`)
                .then(response => {
                    this.empresas = response.data;
                })
        },
        toggleEstado(){
            this.cidades = null
            this.empresas = null
            this.loadCidades(this.selectEstadoId);
        },
        toggleCidade(){
            this.empresas = null
            this.loadEmpresas(this.selectCidadeId);
        }
    },
}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>